import { createFileRoute } from "@tanstack/react-router";
import { PosFigmaLP } from "@/components/posfigma/PosFigmaLP";
// Rafael Alaiti aparece no roster de professores da Orto — reaproveitamos a foto
// até termos um asset dedicado para o Dor.
import rafaelFoto from "@/assets/orto/prof-rafael.jpg.asset.json";

const TITLE = "Pós em Especialização em Dor para Fisioterapeutas | Versão A | FEO";
const DESC =
  "Versão A da LP: pós-graduação 100% online em Dor para Fisioterapeutas. 14 módulos, 360h, reconhecida pelo MEC. Avalie, raciocine e trate com base em evidências.";
const URL = "https://fisioemortopedia.com.br/dor1";

export const Route = createFileRoute("/dor1")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" }, // LP B em teste
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Course",
          name: "Especialização em Dor para Fisioterapeutas",
          description: DESC,
          url: URL,
          provider: {
            "@type": "Organization",
            name: "Fisio em Ortopedia (FEO)",
            sameAs: "https://fisioemortopedia.com.br",
          },
          educationalCredentialAwarded: "Especialização (Pós-Graduação Lato Sensu)",
          hasCourseInstance: {
            "@type": "CourseInstance",
            courseMode: "online",
            courseWorkload: "PT360H",
          },
        }),
      },
    ],
  }),
  component: DorLP1,
});

function DorLP1() {
  return (
    <PosFigmaLP
      product="dor"
      heroBadge="Especialização 100% online"
      heroTitle={["Especialização", "em Dor para", "Fisioterapeutas"]}
      heroSubtitle="Aprenda com decisões dos casos clínicos mais comuns e desafiadores, com foco em raciocínio baseado em evidências."
      coordenadorNome="Rafael Alaiti"
      coordenadorFoto={rafaelFoto.url}
      coordenadorBio="Coordenador da especialização em Dor da FEO. Doutor em Ciências pela USP, com mais de 60 publicações científicas em dor crônica, mecanismos da dor e prática baseada em evidências. Referência nacional em ensino de dor para fisioterapeutas."
      ementaSubtitle="Baixe o PDF com a grade completa, os professores e o cronograma das aulas da especialização em Dor para Fisioterapeutas."
      whatsappUrl="https://nimble.li/o9yokpkm"
      whatsappLabel="Falar com o time no WhatsApp"
    />
  );
}
